// Lightweight in-memory prefetch cache for story detail data + first slide image.
// Used to kick off the story JSON + hero image fetch as soon as a user
// hovers/touches a StoryCard, instead of waiting until they land on the
// story page and React has mounted/parsed params.

const cache = new Map();

function extractIds(to) {
  if (!to) return null;
  const parts = to.split("/").filter(Boolean);
  const slug = parts[parts.length - 1] || "";
  const slugArray = slug.split("-");
  const story_id = slugArray.at(-1);
  const feature_id = slugArray.at(-2);
  if (!story_id || !feature_id) return null;
  return { story_id, feature_id };
}

export function prefetchStory(to) {
  const ids = extractIds(to);
  if (!ids) return null;
  const key = `${ids.feature_id}-${ids.story_id}`;
  if (cache.has(key)) return cache.get(key);

  const promise = fetch(
    `https://www.teluguone.com/news_api/newsDetailedWebStoresJson?story_id=${ids.story_id}&feature_id=${ids.feature_id}`,
    { cache: "no-store" }
  )
    .then((res) => (res.ok ? res.json() : Promise.reject(new Error("prefetch failed"))))
    .then((json) => {
      const slides = json?.detailed_web_stories;
      if (slides && slides[0]?.stimg) {
        // warm the browser cache / decode for the hero image
        const img = new Image();
        img.src = slides[0].stimg;
      }
      return json;
    })
    .catch(() => {
      cache.delete(key);
      return null;
    });

  cache.set(key, promise);
  return promise;
}

export function getPrefetched(to) {
  const ids = extractIds(to);
  if (!ids) return null;
  const key = `${ids.feature_id}-${ids.story_id}`;
  return cache.get(key) || null;
}
